import type { TenantTabProps } from '../TenantDetail';
import { BrandingCard } from './BrandingCard';
import { LogoCard } from './LogoCard';
import { SubscriptionCard } from './SubscriptionCard';

export function BrandingTab(props: TenantTabProps): JSX.Element {
  return (
    <div className="stack lg">
      <div className="grid cols-2 align-start">
        <BrandingCard {...props} />
        <LogoCard {...props} />
      </div>
      <SubscriptionCard {...props} />
    </div>
  );
}
